import { toDateOrNull } from './pip-improvement-activity.model';

export class PipPlanApiModel {
  public Id: number;
  public SubjectProgramRoleId: string;
  public SubjectUserId: string;
  public SubjectName: string;
  public CreatorUserId: string;
  public CreatorName: string;
  public StartDate: Date;
  public ProjectedEndDate: Date | null;
  public EndDate: Date | null;
  public IsComplete: boolean;
  public ResolutionId: number | null;
  public ResolutionName: string | null;
  public NextCheckPointDate: Date | null;
  public LastCheckPointDate: Date | null;

  public deserialize(data: object): this {
    Object.assign(this, data);

    this.StartDate = toDateOrNull(this.StartDate);
    this.ProjectedEndDate = toDateOrNull(this.ProjectedEndDate);
    this.EndDate = toDateOrNull(this.EndDate);
    this.NextCheckPointDate = toDateOrNull(this.NextCheckPointDate);
    this.LastCheckPointDate = toDateOrNull(this.LastCheckPointDate);

    return this;
  }
}
